import React from 'react';
import { formatDollarAmount } from '../../util/EfupUtility';
import { paymentDisplayType } from '../../config/PaymentTypes';
import { format } from 'date-fns';

export default function PaymentRow(props) {
    const rowData = props.rowData;
    const typeInfo = props.typeInfo;

    function generateRow(field) {
        let value = "";
        switch (field) {
            case 'payment-number':
                value = rowData.paymentNumber;
                break;
            case 'payment-type':
                value = paymentDisplayType(rowData.paymentType, rowData.workflowType) ?? rowData.paymentType;
                break;
            case 'party-name':
            case 'party-names':
            case 'vendor':
                value = !rowData.payeeNames.length ? 'Not Available' : rowData.payeeNames.join(', ');
                break;
            case 'date':
                value = format(new Date(rowData.createdDate), 'MM/dd/yyyy');
                break;
            case 'amount':
                value = formatDollarAmount(rowData.amount);
                break;
            case 'status':
                value = rowData.statusCode;
                break;
            case 'payment-method':
                value = rowData.paymentMethod;
                break;
                case 'vendor-id':
                value = rowData.vendorCode;
                break;
            default:
                // Default to empty string if unknown
                value = "";
        }
        const uniqueIdentifier = `efup-data-${field}-${rowData.uuid}`;
        const cellClass = `payment-${field}`;
        return <td key={uniqueIdentifier} className={cellClass} data-testid={uniqueIdentifier}>{value}</td>
    }

    return (
        <tr className="payment-table-row" onClick={() => props.onRowSelect(rowData.uuid, paymentDisplayType(rowData.paymentType, rowData.workflowType) ?? rowData.paymentType)} key={`payment-row-${rowData.uuid}`}
            tabIndex={0} onKeyDown={({key}) => key === "Enter" ? props.onRowSelect(rowData.uuid, paymentDisplayType(rowData.paymentType, rowData.workflowType) ?? rowData.paymentType) : ""}>
            {typeInfo.map(item => {
                return generateRow(item.value);
            })}
        </tr>
    );
}